import { React } from 'react';
import '../stylesheets/LoaderComponent.css';

function LoaderComponent() {

  return (
    <div className='container d-flex justify-content-center align-items-center text-center'>
      <div className="loadingio-spinner-spinner-977el9wwy2v"><div className="ldio-4j5ay0xf86g">
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
      </div></div>
    </div>
  );
}

export default LoaderComponent;